// removed by extract-text-webpack-plugin
module.exports = {"row":"ZKzshSCrScUQQOydWj35e","eventColored":"_3TW8G5n_uu-UHbG5EmZiYs","oddColored":"OzH4_GGYEY1VLal55XuT8","label":"_3ChU-yda4hU-H2hMIxO8xP","value":"yAD85x9ne_JFuxSKeEx7F","innerRow":"_3oh2ZrYTIv4D05I3ocGrKz"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/presentational/Row.module.css
// module id = 2348
// module chunks = 1